export default function handlePushState(route, stepId, carSlug) {
  const urlTemplate = window.location.protocol + '//' + window.location.host + route
  const url = urlTemplate.replace('{car_slug}', carSlug).replace('{page_number}', stepId)

  history.pushState({}, null, url)
}
